import React, { useState } from "react";
import PropTypes from "prop-types";
import ContactHelper from "../../../../entities/contact/contact-helper";
import "./delete-contact-modal.scss";

const DeleteContactModal = ({ show, onHide, contact, onContactDeleted }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleDelete = async () => {
        setIsLoading(true);
        setError(null);
        try {
            await ContactHelper.deleteContact(contact.id);
            onContactDeleted();
            onHide();
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                "Failed to delete contact. Please try again."
            );
        }
        setIsLoading(false);
    };

    if (!show) return null;

    return (
        <div
            className={`custom-modal-overlay ${show ? "show" : ""}`}
            role="dialog"
            aria-labelledby="deleteContactModalTitle"
            aria-hidden={!show}
        >
            <div className="custom-modal-content">
                <div className="modal-header">
                    <h5 className="modal-title mt-0" id="deleteContactModalTitle">
                        Delete Contact
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onHide}
                        aria-label="Close"
                    ></button>
                </div>
                <div className="modal-body">
                    {error && <div className="alert alert-danger mb-3">{error}</div>}
                    <div className="confirmation-content">
                        <p className="confirmation-message">
                            Are you sure you want to delete the contact <strong>{contact?.name}</strong>?
                        </p>
                        <p className="warning-text">This action cannot be undone.</p>
                    </div>
                </div>
                <div className="modal-footer justify-content-end">
                    <button
                        type="button"
                        className="btn"
                        onClick={onHide}
                        disabled={isLoading}
                    >
                        <span>Close</span>
                    </button>
                    <button
                        type="button"
                        className="bouncy-button small btn-danger"
                        onClick={handleDelete}
                        disabled={isLoading}
                    >
                        <span>{isLoading ? "Deleting..." : "Delete"}</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

DeleteContactModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    contact: PropTypes.object,
    onContactDeleted: PropTypes.func.isRequired,
};

export default DeleteContactModal;